import React from "react";

const Avatar = (props) => {
    const withLaptop = props.withLaptop;

   return (<div className="container-girl girl">
        <div className="profile">
            <div className="group">
                <div className="hair"></div>
                <div className="ear"></div>
                <div className="ear right"></div>
                <div className="face"></div>
                <div className="glasses">
                    <div className="glasses-center"></div>
                </div>
                <div className={ withLaptop ? "eyeslash movement" : "eyeslash" }></div>
                <div className={ withLaptop ? "eye movement" : "eye"}></div>
                <div className="blush"></div>
                <div className="fringe"></div>
                <div className="nose"></div>
                <div className="mouth">
                    <div className="tongue"></div>
                </div>
            </div>
        </div>
        {withLaptop &&
            <div className="laptop">
                <div className="container-laptop">
                <div className="papaya"></div>
                </div>
            </div>
        }
    </div>)
};

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/Avatar.js